var React = require('react');
var CanvasJS = require('@canvasjs/charts');
CanvasJS = CanvasJS.Chart ? CanvasJS : window.CanvasJS;
// require('export-canvasjs-chart-data-as-csv');

// 👇 Add this helper function
function addCustomCSVExport(chartInstance, filename = "chart-data") {
	if (!chartInstance.exportEnabled || !chartInstance._toolBar) return;

	// Avoid duplicate buttons
	if (chartInstance._toolBar.querySelector('.custom-csv-button')) return;

	const f = ","; // CSV delimiter
	const e = "\n"; // Line delimiter

	function extractCSV(dataSeriesArray) {
		// ✅ Only include visible series
		const visibleSeries = dataSeriesArray.filter(series => series.visible !== false);
		const allPointsMap = new Map();
		const seriesNames = visibleSeries.map(s => s.name || s.legendText || "Series");

		visibleSeries.forEach((series, i) => {
			series.dataPoints.forEach(point => {
				const x = point.x;
				if (!allPointsMap.has(x)) {
					allPointsMap.set(x, { x: x });
				}
				allPointsMap.get(x)[seriesNames[i]] = point.y;
			});
		});

		const data = Array.from(allPointsMap.values());
		const xHeaderName = chartInstance.options.axisX?.title || "Time";
		const headers = [xHeaderName, ...seriesNames];
		let csv = headers.join(f) + e;

		data.forEach(row => {
			const line = headers.map(k => {
				if (k === xHeaderName) {
					const val = row.x;
					if (val instanceof Date) return val.toISOString();
					return val;
				}
				return row[k] !== undefined ? row[k] : "";
			}).join(f);
			csv += line + e;
		});

		return csv;
	}

	const btn = document.createElement("div");
	btn.className = "custom-csv-button";
	btn.textContent = "Save as CSV";
	btn.setAttribute("style", `padding: 12px 8px; cursor: pointer; background-color: ${chartInstance.toolbar.itemBackgroundColor}; color: ${chartInstance.toolbar.fontColor}`);

	btn.addEventListener("mouseover", () => {
		btn.style.backgroundColor = chartInstance.toolbar.itemBackgroundColorOnHover;
		btn.style.color = chartInstance.toolbar.fontColorOnHover;
	});
	btn.addEventListener("mouseout", () => {
		btn.style.backgroundColor = chartInstance.toolbar.itemBackgroundColor;
		btn.style.color = chartInstance.toolbar.fontColor;
	});
	btn.addEventListener("click", () => {
		let csv = extractCSV(chartInstance.options.data);
		if (!csv) return;

		let uri = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
		let link = document.createElement("a");
		link.setAttribute("href", uri);
		link.setAttribute("download", filename + ".csv");
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	});

	chartInstance._toolBar.lastChild.appendChild(btn);
}
class CanvasJSChart extends React.Component {
	static _cjsContainerId = 0;
	constructor(props) {
		super(props);
		this.options = props.options || {};
		this.containerProps = props.containerProps || { width: "100%", position: "relative" };
		this.containerProps.height =
			props.containerProps?.height || this.options.height ? this.options.height + "px" : "400px";
		this.chartContainerId = "canvasjs-react-chart-container-" + CanvasJSChart._cjsContainerId++;
	}
	componentDidMount() {
		this.chart = new CanvasJS.Chart(this.chartContainerId, this.options);
		this.chart.render();

		// ✅ Inject CSV export after render
		addCustomCSVExport(this.chart);

		if (this.props.onRef) this.props.onRef(this.chart);
	}
	shouldComponentUpdate(nextProps) {
		return !(nextProps.options === this.options);
	}
	componentDidUpdate() {
		this.chart.options = this.props.options;
		this.chart.render();

		// ✅ Re-inject CSV export after re-render
		addCustomCSVExport(this.chart);
	}
	componentWillUnmount() {
		this.chart.destroy();
		if (this.props.onRef) this.props.onRef(undefined);
	}
	render() {
		return <div id={this.chartContainerId} style={this.containerProps} />;
	}
}

var CanvasJSReact = {
	CanvasJSChart: CanvasJSChart,
	CanvasJS: CanvasJS
};

export default CanvasJSReact;
